jQuery(document).ready(function() {
    var screenWidth = jQuery(window).width();

    if(screenWidth >= 963) {
        jQuery(document).on('mouseenter', '.tooltip-info', function(e) {
            var container = jQuery(this).children('.tooltip-info-container');
            container.stop().fadeIn(150);
        });
        jQuery(document).on('mouseleave', '.tooltip-info', function() {
            var container = jQuery(this).children('.tooltip-info-container');
            container.stop().fadeOut(150);
        });
    } else {
        jQuery(document).on('click', function(e) {
            if(jQuery(e.target).closest('.tooltip-info.open').length === 0) {
                closeAllTooltips();
            }
        });

        function closeAllTooltips()
        {
            var openTooltips = jQuery('.tooltip-info.open');

            openTooltips.find('.tooltip-info-container').fadeOut(150);
            openTooltips.removeClass('open');
        }

        jQuery(document).on('click', '.tooltip-info', function(e) {
            if (jQuery(e.target).hasClass('tooltip-info')) {
                var container = jQuery(this).children('.tooltip-info-container');

                closeAllTooltips();

                jQuery(this).toggleClass('open');
                container.stop().fadeToggle(150);
            }
        });
    }
});
